const BLUE_STEPS = ["#C7D2F0", "#A9BAE8", "#8AA1E0", "#6B89D8", "#4C71D0", "#3248CA"];

/**
 * Azul claro -> azul oscuro segun el rango de cada valor dentro de la lista
 * (el mas bajo, mas claro; el mas alto, mas oscuro). Evita depender de un
 * color fijo por categoria (fragil si esa categoria no tiene un token de
 * paleta MUI registrado — ver bug en dropout/persistence por subgrupo).
 */
export function blueScaleByRank(values) {
    const order = values.map((_, i) => i).sort((a, b) => values[a] - values[b]);
    const colors = new Array(values.length);
    order.forEach((originalIndex, rank) => {
        const step = Math.round((rank / Math.max(1, values.length - 1)) * (BLUE_STEPS.length - 1));
        colors[originalIndex] = BLUE_STEPS[step];
    });
    return colors;
}
